import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { DispatchDeviceApiService } from '../CommonController/dispatch-device-api-service';
import { exportAsCsvFile } from '../shared/function/exportDataToCsv';

@Component({
  selector: 'app-dispatch-device',
  templateUrl: './dispatch-device.component.html',
  styleUrls: ['./dispatch-device.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    CommonPaginationComponent,
    NgxPaginationModule,
  ],
})
export class DispatchDeviceComponent implements OnInit {
  addDispatchDeviceForm: FormGroup;

  fileToUpload: File | null = null; // Store the file outside the form
  isUploadBoxVisible = true;
  fileUploaded = false;
  exportData = [];

  userPermission = [];
  loggedId = '';

  dispatchUploadedDevicePage = 1;
  dispatchUploadedDeviceSize = 10;
  dispatchUploadedDeviceList = [];

  dispatchDuplicateDevicePage = 1;
  dispatchDuplicateDeviceSize = 10;
  dispatchDuplicateDeviceList = [];

  dispatchInvalidDevicePage = 1;
  dispatchInvalidDeviceSize = 10;
  dispatchInvalidDeviceList = [];

  constructor(
    public dispatchDeviceApiService: DispatchDeviceApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setAddDispatchDeviceForm();
    this.isUploadBoxVisible = true;
  }

  checkPermission() {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Dispatch Device' && element.create === false) {
        this.navigateBack();
      }
    });
  }

  setAddDispatchDeviceForm() {
    this.addDispatchDeviceForm = this.fb.group({
      dispatchDetails: new FormControl('', [Validators.required]),
      file: new FormControl('', [Validators.required]),
    });
  }

  onFileChange(ev) {
    try {
      if (ev.target.files && ev.target.files.length > 0) {
        const file = ev.target.files[0];

        if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
          // Store file in variable (not the form)
          this.addDispatchDeviceForm.get('file').setValue(file.name);
          this.fileToUpload = file;
          this.fileUploaded = true;
        } else {
          this.commonApiService.openSnackbar(
            'Please upload a valid Excel file'
          );
        }
      } else {
        this.fileToUpload = null;
        this.fileUploaded = false;
        this.addDispatchDeviceForm.get('file').setValue('');
      }
    } catch (error) {
      this.commonApiService.openSnackbar(
        error.error.message || 'Please upload a valid Excel file'
      );
      this.fileToUpload = null;
      this.addDispatchDeviceForm.get('file').setValue('');
      this.fileUploaded = false;
    }
  }

  // saveDeviceDetails() {
  //   // Clear existing lists before starting a new upload
  //   this.dispatchUploadedDeviceList = [];
  //   this.dispatchDuplicateDeviceList = [];
  //   this.dispatchInvalidDeviceList = [];

  //   // Create FormData for file upload
  //   const formData = new FormData();
  //   if (this.fileToUpload) {
  //     formData.append('file', this.fileToUpload); // Attach the file
  //   } else {
  //     this.commonApiService.openSnackbar(
  //       'Please upload file before submitting.'
  //     );
  //   }

  //   // Retrieve userId from session storage
  //   const userId = this.loggedId;
  //   if (userId) {
  //     formData.append('userId', userId); // Append userId dynamically
  //   } else {
  //     this.commonApiService.openSnackbar(
  //       'User ID not found. Please log in again.'
  //     );
  //     return; // Stop execution if userId is missing
  //   }

  //   // Attach form values (if any) to the FormData
  //   const payload = this.addDispatchDeviceForm.value;
  //   for (const key in payload) {
  //     if (payload[key] && key !== 'file') {
  //       formData.append(key, payload[key]);
  //     }
  //   }

  //   this.spinner.show();

  //   this.dispatchDeviceApiService
  //     .saveDispatchDataUsingExcel(formData)
  //     .subscribe({
  //       next: (res) => {
  //         this.spinner.hide();

  //         if (res.success) {
  //           // Check success using 'success' property
  //           this.isUploadBoxVisible = false;
  //           this.addDispatchDeviceForm.reset();
  //           this.commonApiService.openSnackbar(res.message);

  //           // Map the successfully uploaded devices from `data`
  //           if (
  //             res.data.savedDispatchDevices &&
  //             res.data.savedDispatchDevices.length > 0
  //           ) {
  //             this.dispatchUploadedDeviceList = res.data.savedDispatchDevices;
  //           }

  //           // Map the error messages for invalid devices
  //           if (
  //             res.data.duplicateDispatchDevices &&
  //             res.data.duplicateDispatchDevices.length > 0
  //           ) {
  //             this.dispatchDuplicateDeviceList =
  //               res.data.duplicateDispatchDevices;
  //           }

  //           // Map the error messages for invalid devices
  //           if (
  //             res.data.invalidDispatchDevices &&
  //             res.data.invalidDispatchDevices.length > 0
  //           ) {
  //             this.dispatchInvalidDeviceList = res.data.invalidDispatchDevices;
  //           }

  //           this.commonApiService.openSnackbar(res.message);
  //         } else {
  //           this.commonApiService.openSnackbar(
  //             'Failed to upload dispatch data'
  //           );
  //         }
  //       },
  //       error: (error) => {
  //         this.spinner.hide();
  //         this.commonApiService.openSnackbar(
  //           error.error.message ||
  //             'An error occurred while uploading dispatch data'
  //         );
  //       },
  //     });
  // }

  saveDeviceDetails() {
    // Clear existing lists before starting a new upload
    this.dispatchUploadedDeviceList = [];
    this.dispatchDuplicateDeviceList = [];
    this.dispatchInvalidDeviceList = [];

    // Create FormData for file upload
    const formData = new FormData();
    if (this.fileToUpload) {
      formData.append('file', this.fileToUpload); // Attach the file
    } else {
      this.commonApiService.openSnackbar(
        'Please upload file before submitting.'
      );
      return;
    }

    // Attach form values (if any) to the FormData
    const payload = this.addDispatchDeviceForm.value;
    for (const key in payload) {
      if (payload[key] && key !== 'file') {
        formData.append(key, payload[key]);
      }
    }

    this.spinner.show();

    this.dispatchDeviceApiService
      .saveDispatchDataUsingExcel(formData)
      .subscribe({
        next: (res) => {
          this.spinner.hide();

          if (res.success) {
            this.isUploadBoxVisible = false;
            this.addDispatchDeviceForm.reset();
            this.commonApiService.openSnackbar(res.message);

            if (res.data.savedDispatchDevices?.length > 0) {
              this.dispatchUploadedDeviceList = res.data.savedDispatchDevices;
            }

            if (res.data.duplicateDispatchDevices?.length > 0) {
              this.dispatchDuplicateDeviceList =
                res.data.duplicateDispatchDevices;
            }

            if (res.data.invalidDispatchDevices?.length > 0) {
              this.dispatchInvalidDeviceList = res.data.invalidDispatchDevices;
            }
          } else {
            this.commonApiService.openSnackbar(
              'Failed to upload dispatch data'
            );
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(
            error.error.message ||
              'An error occurred while uploading dispatch data'
          );
        },
      });
  }

  downloadMyFile() {
    if (confirm('Are You Sure?')) {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '../../assets/Sample_Dispatch_Sheet.xlsx');
      link.setAttribute('download', `Sample_Dispatch_Sheet.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }
  exportToExcelDuplicateDispatchedDeviceData(dispatchDuplicateDeviceList) {
    if (confirm('Are you sure?')) {
      this.exportData = dispatchDuplicateDeviceList;
      exportAsCsvFile(this.exportData, 'Duplicate_Dispatched_Device_Details_');
      this.commonApiService.openSnackbar('File Ready For Download.');
    }
  }

  exportToExcelInvalidDispatchedDeviceData(dispatchInvalidDeviceList) {
    if (confirm('Are you sure?')) {
      this.exportData = dispatchInvalidDeviceList;
      exportAsCsvFile(this.exportData, 'Invalid_Dispatched_Device_Details_');
      this.commonApiService.openSnackbar('File Ready For Download.');
    }
  }

  exportToExcelUploadedDispatchedDeviceData(dispatchUploadedDeviceList) {
    if (confirm('Are you sure?')) {
      this.exportData = dispatchUploadedDeviceList;
      exportAsCsvFile(this.exportData, 'Uploaded_Dispatched_Device_Details_');
      this.commonApiService.openSnackbar('File Ready For Download.');
    }
  }

  onPageChangeDispatchInvalidDeviceList(event) {
    this.dispatchUploadedDevicePage = event;
  }

  onSizeChangeDispatchInvalidDeviceList(newPageSize) {
    this.dispatchUploadedDeviceSize = newPageSize;
    this.dispatchUploadedDevicePage = 1;
  }

  onPageChangeDispatchDuplicateDeviceList(event) {
    this.dispatchDuplicateDevicePage = event;
  }

  onSizeChangeDispatchDuplicateDeviceList(newPageSize) {
    this.dispatchDuplicateDeviceSize = newPageSize;
    this.dispatchDuplicateDevicePage = 1;
  }

  onPageChangeDispatchUploadedDeviceList(event) {
    this.dispatchInvalidDevicePage = event;
  }

  onSizeChangeDispatchUploadedDeviceList(newPageSize) {
    this.dispatchInvalidDeviceSize = newPageSize;
    this.dispatchInvalidDevicePage = 1;
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
